var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-one"},[_c('div',{staticClass:"box"},[_c('h1',[_vm._v("新型攻击方法")]),_c('div',{staticClass:"text"},[_c('p',[_vm._v(" "+_vm._s(_vm.content)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }